import { Injectable, Inject } from '@angular/core';


export class PolicyAgentDO {
	// private firstName;
	// private lasteName;
	public id: Number = null;

	public guid: any = null;

	public agentNum: String = null;

	public primaryFl: Boolean = null;

	public firstName: String = null;

	public lastName: String = null;

	public companyContactUserId: any = null;

	public clientId: any = null;

	public channelCd: any = null;

	public companyCd: any = null;

	public subChannelCd: any = null;

	public partnerbranchCd: any = null;

	public vatApplicableFl: any = null;

	public companyBranchCd: any = null;

	public commissionPercent: Number = null;

	public getId(): Number {
		return this.id;
	}
	public getAgentNum(): String {
		return this.agentNum;
	}
	public setAgentNum(agentNum): void {
		this.agentNum = agentNum;
	}
	public isPrimaryFl(): Boolean {
		return this.primaryFl;
	}
	public setPrimaryFl(primaryFl): void {
		this.primaryFl = primaryFl;
	}

	public getCommissionPercent(): Number {
		return this.commissionPercent;
	}
	public setCommissionPercent(commissionPercent): void {
		this.commissionPercent = commissionPercent;
	}
	public setId(id): void {
		this.id = id;
	}
	// public getObjectName() {
	// 	return this.PolicyAgentDO.class.getSimpleName();
	// }



}
